<footer class="footer">
  <div class="container">
    <div class="row justify-content-between">
      <span class="text-light w-auto">
        © 2025 Shreyash Kalaskar. All rights reserved.
      </span>
      <span class="text-light w-auto"
        >Made with <img src="assets/images/svg/heart.svg" class="footer-icon" alt="heart" /> using
        Angular and Bootstrap</span
      >
      <button class="cursor-pointer  up-arrow d-flex justify-content-center align-items-center" (click)="moveToTop()">
        <img src="assets/images/svg/up-arrow.svg" alt="up-arrow" class="footer-icon">
      </button>
    </div>
  </div>
</footer>
